// @flow
import * as React from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import type { Node } from 'react';
import withHeaderAndFooter from '../../HOCs/withHeaderAndFooter';
import { styles } from './styles.js';
import { isStagingEnv } from '../../utils';
import RichTextBlock from '../../components/richTextBlock';
import {LocalesConsumer} from '../../utils/locales';
import type {ILocalesTransformers} from '../../utils/locales';

type Props = {
    classes: Object,
    file: Object,
    text: Object,
    theme: Object
}

type State = {}

class CommonText extends React.PureComponent<Props, State> {
    constructor(props: Object) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (isStagingEnv()) {
            window.layout = this;
        }
    }

    render(): any {
        const { classes, file } = this.props;

        return (
            <LocalesConsumer>
                {
                    ({translate}: ILocalesTransformers): React.Node => (
                        <div id="text-content" className={classes.root} suppressHydrationWarning={true}>
                            {!file.text
                                ? (
                                    <div className={classes.container}>
                                        <Typography
                                            color="default"
                                            className={classes.headline}
                                            component="h1"
                                            paragraph={true}
                                        >
                                            {translate('general.press')/* TODO pass a variable*/}
                                        </Typography>
                                        <Paper className={classes.paper}>
                                            <List component="nav">
                                                {Object.keys(file).map((name: string, j: number): Node => {
                                                    let article = file[name];
                                                    let count = Object.keys(file).length;

                                                    return (
                                                        <React.Fragment key={j}>
                                                            <ListItem
                                                                button
                                                                component="a"
                                                                href={`/press/${name}`}
                                                            >
                                                                <Grid
                                                                    container
                                                                    direction={'column'}
                                                                    spacing={1}
                                                                >
                                                                    <Grid item>
                                                                        <Typography
                                                                            variant={'caption'}
                                                                            className={classes.dateCaption}
                                                                        >
                                                                            {article.date}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography
                                                                            color="primary"
                                                                            className={classes.subheadline}
                                                                            component="h2"
                                                                        >
                                                                            {article.title}
                                                                        </Typography> </Grid>

                                                                    <Grid item>
                                                                        <Typography
                                                                            className={classes.section}
                                                                            component="p"
                                                                        >
                                                                            {article.short}
                                                                        </Typography>
                                                                    </Grid>

                                                                </Grid>
                                                            </ListItem>
                                                            {j + 1 < count ? <Divider/> : null}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </List>
                                        </Paper>
                                    </div>
                                ) : (
                                    Object.keys(file.text).map((headline: string, i: number): Node => {
                                        return (
                                            <div key={i} className={classes.container}>
                                                <Typography
                                                    color="default"
                                                    className={classes.headline}
                                                    component="h1"
                                                    paragraph={true}
                                                >
                                                    {headline}
                                                </Typography>
                                                <Paper className={classes.paper}>
                                                    {Object.keys(file.text[headline])
                                                        .map((subheadline: string, j: number): Node => {
                                                            return (
                                                                <div key={j}>
                                                                    <Typography
                                                                        color="primary"
                                                                        className={classes.subheadline}
                                                                        component="h2"
                                                                        paragraph={true}
                                                                    >
                                                                        {subheadline}
                                                                    </Typography>
                                                                    {Object.keys(file.text[headline][subheadline])
                                                                        .map((title: string, k: number): Node => {
                                                                            if (!file.text[headline][subheadline][title]
                                                                                .hasOwnProperty('raw')) {
                                                                                return (<div key={k}>

                                                                                    <RichTextBlock
                                                                                        text={file.text[headline][subheadline].raw}
                                                                                        className={classes.section}
                                                                                        classes={{
                                                                                            link: classes.link,
                                                                                        }}
                                                                                    />
                                                                                </div>);
                                                                            } else {
                                                                                return (
                                                                                    <div key={k}>

                                                                                        <Typography
                                                                                            className={classes.title}
                                                                                            component="h3"
                                                                                            paragraph
                                                                                            id={title.toLowerCase()
                                                                                                .replace(/[,\\/.;:]/g, '')
                                                                                                .replace(/[ ]/g, '-')}
                                                                                            tabIndex="0"
                                                                                        >
                                                                                            {title}
                                                                                        </Typography>
                                                                                        <RichTextBlock
                                                                                            text={file.text[headline][subheadline][title]
                                                                                                .raw}
                                                                                            className={classes.section}
                                                                                            classes={{
                                                                                                link: classes.link,
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })}
                                                                </div>
                                                            );
                                                        })}
                                                </Paper>
                                            </div>
                                        );
                                    })
                                )}
                        </div>
                    )
                }
            </LocalesConsumer>
        );
    }
}

export default withHeaderAndFooter(withStyles(styles, { withTheme: true })(CommonText));
